import React from 'react';
import {v4} from 'node-uuid';
import {CREDENTIAL_TYPE_LABELS} from '../../constants';

const EventDetailsFilter = ({eventDetails, changeEventDetailsFilter}) => {
  const {
    filter,
    assignedCredentials,
    vipGuestCredentials,
    vipSingleCredentials,
    workingSingleCredentials,
    modelCredentials,
    paddockGuestWristbandCredentials,
    vendorGuestWristbandCredentials,
    broadcastGuestWristbandCredentials,
    mediaSingleCredentials
  } = eventDetails;

  const FILTERS = {
    all: assignedCredentials.length,
    guest: vipGuestCredentials.length,
    paddock_guest_wristband: paddockGuestWristbandCredentials.length,
    vendor_guest_wristband: vendorGuestWristbandCredentials.length,
    broadcast_guest_wristband: broadcastGuestWristbandCredentials.length,
    hotpit_guest: vipSingleCredentials.length,
    working_single: workingSingleCredentials.length,
    media_single: mediaSingleCredentials.length,
    model: modelCredentials.length,
  };

  return (
    <div>
      <ul className="nav nav-tabs card-counts" role="tablist">
        {Object.keys(FILTERS).map((filterName) => (
          <Filter
            key={v4()}
            currentFilter={filter}
            changeEventDetailsFilter={changeEventDetailsFilter}
            filterName={filterName}
            colorClassName={colorFilterName(filterName)}
          >
            {getFilterLabel(filterName)} ({FILTERS[filterName]})
          </Filter>
        ))}
      </ul>
    </div>
  );
}

const Filter = ({currentFilter, filterName, changeEventDetailsFilter, children, colorClassName}) => (
  <li role="presentation" className={currentFilter === filterName ? 'active' : ''}>
    <a aria-controls={filterName} role="tab" data-toggle="tab" onClick={() => changeEventDetailsFilter(filterName)}>
      <span>
        <span className={colorClassName}>
          {children}
        </span>
      </span>
    </a>
  </li>
);

const colorFilterName = (filterName) => {
  if (filterName === "all") return "color-all";
  return CREDENTIAL_TYPE_LABELS[filterName] ? `color-${CREDENTIAL_TYPE_LABELS[filterName]["type_label"]}` : 'color-default';
}

const getFilterLabel = (filterName) => {
  if (filterName === "all") return "All";
  return CREDENTIAL_TYPE_LABELS[filterName] ? CREDENTIAL_TYPE_LABELS[filterName]["filter_label"] : '';
}

export default EventDetailsFilter;



// WEBPACK FOOTER //
// ./src/components/Events/EventDetailsFilter.js